import { ScrollLocker } from '../utils/scrolllocker';
const $wrapper = $('.js-wrapper');

if ($('.js-popup-hotspot').length) {
  const popupClose = document.createElement('div');
  popupClose.setAttribute('class', 'popup-hotspot-overlay js-popup-overlay')
  document.querySelector('.main').appendChild(popupClose)
}

const closePopup = () => {
  $('.js-popup-hotspot.is-active').removeClass('is-active');
  $('.js-popup-overlay').removeClass('is-active');
  ScrollLocker.unlock();
  $wrapper.removeClass('has-open-popup');
}

$('.js-hotspot-trigger').on('click', (e) => {
  const $this = $(e.target);
  const target = $this.data('target');
  const $hotspot = $this.parent().find(`.js-popup-hotspot[data-id="${target}"`);
  if ($hotspot.length) {
    $hotspot.addClass('is-active');
    $('.js-popup-overlay').addClass('is-active');
    ScrollLocker.lock();
    $wrapper.addClass('has-open-popup');
  }
});

$('.js-toggle-popup').on('click', (e) => {
  closePopup();
})

$('.js-popup-hotspot').each((index, popup) => {
  const $popup = $(popup);
  $popup.on('click', (e) => {
    const clickIsInContent = $(e.target).parents('.popup__container').length || $(e.target).hasClass('.popup__container')
    if (!clickIsInContent) {
      closePopup();
    }
  })
})
